import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ConfigService } from 'src/app/services/config.service';

@Injectable({
  providedIn: 'root'
})
export class DashboardService {
  endpoint:any;
  constructor(private http: HttpClient, private configService: ConfigService) {
    this.endpoint = this.configService.endpoints;
   }

  getLabChartDailyData(){
    return this.http.get<any>(`${this.endpoint.APIEndpoint}/CaseOrder/generate/daily/statistics`);
  }

  getLabChartMonthData(){
    return this.http.get<any>(`${this.endpoint.APIEndpoint}/CaseOrder/generate/monthly/statistics`);
  }

  getLabNotifications(filterModel, customFilter) {
    return this.http.get<any>(`${this.endpoint.APIEndpoint}/labnotifications/list/?${filterModel.PageSize}&${filterModel.RunCount}&${filterModel.StartPageNo}&${filterModel.SortExpression}&${customFilter}`);
  }

}
